'use client';

import { __makeTemplateObject } from '../../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import styledCss from '../../../../../Utils/styledCss.js';
import { animSlide } from '../../../../../TreeSelect/components/Dropdown/Dropdown.css.js';

var RepsonsiveChildWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    ", ";\n    transition: all 0.25s ease-in-out;\n\n    animation: ", " 0.25s ease-in-out\n        forwards;\n\n    ", "\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    ", ";\n    transition: all 0.25s ease-in-out;\n\n    animation: ", " 0.25s ease-in-out\n        forwards;\n\n    ", "\n"])), styledCss.scrollbar, function (_a) {
    var side = _a.side;
    return (side === 'right' ? animSlide.second.open : animSlide.first.close);
}, function (_a) {
    var isShow = _a.isShow, side = _a.side;
    if (!isShow && side === 'right') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), animSlide.second.close);
    }
    if (!isShow && side === 'left') {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), animSlide.first.open);
    }
    return '';
});
var templateObject_1, templateObject_2, templateObject_3;

export { RepsonsiveChildWrapper };
//# sourceMappingURL=ResponsiveBody.css.js.map
